export const LOCALES = {
  en: 'English',
  es: 'Spanish',
  zh: 'Mandarin (Simplified)'
};
